import { render, staticRenderFns } from "./InserirAnexoForm.vue?vue&type=template&id=19e3f924"
import script from "./InserirAnexoForm.vue?vue&type=script&lang=js"
export * from "./InserirAnexoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports